"use client"

import { useEffect, useRef } from "react"
import styled from "styled-components"
import { motion } from "framer-motion"

const BackgroundContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  overflow: hidden;
  pointer-events: none;
`

const Particle = styled(motion.div)`
  position: absolute;
  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--highlight) 100%);
  border-radius: 50%;
  opacity: 0.05;
`

const AnimatedBackground = () => {
  const containerRef = useRef(null)

  useEffect(() => {
    // Create particles only on client-side
    if (typeof window !== "undefined" && containerRef.current) {
      const container = containerRef.current
      const particles = []

      // Clear any existing particles
      container.innerHTML = ""

      // Create new particles
      for (let i = 0; i < 15; i++) {
        const size = Math.random() * 300 + 100 // 100-400px
        const particle = document.createElement("div")

        // Set particle styles
        particle.style.width = `${size}px`
        particle.style.height = `${size}px`
        particle.style.left = `${Math.random() * 100}%`
        particle.style.top = `${Math.random() * 100}%`
        particle.style.position = "absolute"
        particle.style.background =
          "linear-gradient(135deg, rgba(79, 141, 251, 0.05) 0%, rgba(108, 156, 255, 0.05) 100%)"
        particle.style.borderRadius = "50%"
        particle.style.opacity = "0.05"
        particle.style.transform = "scale(0)"

        // Add to container
        container.appendChild(particle)
        particles.push(particle)

        // Animate with random duration and delay
        const duration = 15 + Math.random() * 30 // 15-45s
        const delay = Math.random() * 5 // 0-5s

        // Use Web Animation API for better performance
        particle.animate(
          [
            { transform: "scale(0) translate(0, 0)", opacity: 0 },
            { transform: "scale(1) translate(0, 0)", opacity: 0.05, offset: 0.2 },
            {
              transform: `scale(0.8) translate(${Math.random() * 100 - 50}px, ${Math.random() * 100 - 50}px)`,
              opacity: 0.05,
              offset: 0.8,
            },
            { transform: "scale(0) translate(0, 0)", opacity: 0 },
          ],
          {
            duration: duration * 1000,
            delay: delay * 1000,
            iterations: Number.POSITIVE_INFINITY,
            easing: "ease-in-out",
            direction: "alternate",
          },
        )
      }

      // Cleanup function
      return () => {
        particles.forEach((particle) => {
          if (particle.getAnimations) {
            particle.getAnimations().forEach((anim) => anim.cancel())
          }
        })
      }
    }
  }, [])

  return <BackgroundContainer ref={containerRef} />
}

export default AnimatedBackground

